import React from 'react';
import { PROJECTS as projects } from '../data/profile';

export default function Projects() {
  return (
    <section id="projects" className="section">
      <div className="container">
        <h2>Projects</h2>
        <p className="muted" style={{ marginBottom: 18 }}>Selected work and experiments.</p>
        <div className="grid">
          {projects.map(p => (
            <div key={p.title} className="card reveal">
              <h3 style={{ marginBottom: '8px' }}>{p.title}</h3>
              <p style={{ marginBottom: 16 }}>{p.desc}</p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: '16px' }}>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', flex: 1 }}>
                  {p.tags.map(t => (
                    <span key={t} className="chip">{t}</span>
                  ))}
                </div>
                {p.link && (
                  <a 
                    href={p.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    aria-label={`View ${p.title} project`}
                    style={{ 
                      display: 'inline-flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      backgroundColor: 'var(--accent)',
                      color: 'white',
                      textDecoration: 'none',
                      fontSize: '16px',
                      transition: 'transform 0.2s ease',
                      flexShrink: 0
                    }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  >
                    ↗
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
